import React, { useState } from 'react';
import {
  Stack,
  TextField,
  Button,
  MenuItem,
  InputAdornment,
} from '@mui/material';
import { useTranslation } from 'src/text';
import { ExpenseCategory, useExpenses } from '../expense-context';
import { addButton, amountField, categoryField, paymentField } from '../styles';

const categories: ExpenseCategory[] = [
  'Ops',
  'Marketing',
  'Staff',
  'Inventory',
  'Other',
];

export const ExpenseForm: React.FC = () => {
  const { expenseLabels } = useTranslation();
  const { addExpense } = useExpenses();
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState<ExpenseCategory>('Ops');
  const [amount, setAmount] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('Card');

  const categoryLabels: Record<ExpenseCategory, string> = {
    Ops: expenseLabels.categories.Ops,
    Marketing: expenseLabels.categories.Marketing,
    Staff: expenseLabels.categories.Staff,
    Inventory: expenseLabels.categories.Inventory,
    Other: expenseLabels.categories.Other,
  };

  const handleSubmit = () => {
    const value = parseFloat(amount || '0');
    if (!description.trim() || isNaN(value) || value <= 0) return;
    addExpense({
      description: description.trim(),
      category,
      amount: value,
      date: new Date().toISOString(),
      paymentMethod,
    });
    setDescription('');
    setAmount('');
  };

  return (
    <Stack spacing={1.5} direction={{ xs: 'column', sm: 'row' }}>
      <TextField
        fullWidth
        label={expenseLabels.formDescriptionLabel}
        placeholder={expenseLabels.formDescriptionPlaceholder}
        value={description}
        onChange={e => setDescription(e.target.value)}
      />
      <TextField
        select
        label={expenseLabels.formCategoryLabel}
        value={category}
        onChange={e => setCategory(e.target.value as ExpenseCategory)}
        sx={categoryField}>
        {categories.map(cat => (
          <MenuItem key={cat} value={cat}>
            {categoryLabels[cat]}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        label={expenseLabels.formAmountLabel}
        type="number"
        value={amount}
        onChange={e => setAmount(e.target.value)}
        InputProps={{
          startAdornment: <InputAdornment position="start">$</InputAdornment>,
        }}
        sx={amountField}
      />
      <TextField
        label={expenseLabels.formPaymentLabel}
        value={paymentMethod}
        onChange={e => setPaymentMethod(e.target.value)}
        sx={paymentField}
      />
      <Button variant="contained" onClick={handleSubmit} sx={addButton}>
        {expenseLabels.formAddButton}
      </Button>
    </Stack>
  );
};
